import { render, staticRenderFns } from "./KpiAdmin.vue?vue&type=template&id=d2c980de&scoped=true&"
import script from "./KpiAdmin.vue?vue&type=script&lang=js&"
export * from "./KpiAdmin.vue?vue&type=script&lang=js&"
import style0 from "./KpiAdmin.vue?vue&type=style&index=0&id=d2c980de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c980de",
  null
  
)

export default component.exports